import { BrowserHistory } from 'history';
import { FC, memo, useLayoutEffect, useState } from 'react';
import { BrowserRouterProps as NativeBrowserRouterProps, Router } from 'react-router-dom';

import { IAppRouter } from '@/common/components/AppRouter/interface';
import { BASE_URL } from '@/common/constants';
import { HISTORY } from '@/common/utils/history';

export interface BrowserRouterProps extends Omit<NativeBrowserRouterProps, 'window'> {
  history: BrowserHistory;
}

export const BrowserRouter: FC<BrowserRouterProps> = memo(({ history, ...restProps }) => {
  const [state, setState] = useState({
    action: history.action,
    location: history.location,
  });

  useLayoutEffect(() => history.listen(setState), [history]);

  return (
    <Router
      {...restProps}
      location={state.location}
      navigationType={state.action}
      navigator={history}
    />
  );
});

const AppRouter = ({ children }: IAppRouter) => (
  <BrowserRouter basename={BASE_URL} history={HISTORY}>
    {children}
  </BrowserRouter>
);

export { AppRouter };
